/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import AccountTitleEvent from '../../event/AccountTitleEvent'
import AccountTitleOptionState from './state/AccountTitleOptionState'

class AccountTitleOptionsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AccountTitleEvent.fetchAll:
        const titles = payload.titles.map(title => {
          return new AccountTitleOptionState().mergeModel(title)
        })
        return List(titles)
      default:
        return state
    }
  }
}

export default new AccountTitleOptionsStore()
